import { Component, Input, HostListener } from '@angular/core';
import { Util } from '../../core-utilities/Util';

@Component({
    selector: 'place-near',
    template: `
        <div
            [ngStyle]="{
                'right.px': getRight(),
                'top.px': getTop(),
                'left.px': getLeft(),
                'width.px': this.width
            }"
            style="position: fixed; z-index: 500; background-color: white;margin-top:5px;"
        >
            <ng-content> </ng-content>
        </div>
    `,
    standalone: false
})
export class PlaceNearComponent {
    @Input()
    elementRef: any;

    @Input()
    width: number;
    left: number;
    top: number;
    right: number;

    constructor(private util: Util) {}

    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.clearValues();
    }

    @HostListener('window:resize')
    onresize() {
        this.clearValues();
    }

    private clearValues() {
        this.top = null;
        this.right = null;
        this.left = null;
    }

    private getRect() {
        if (this.elementRef.getBoundingClientRect) {
            return this.elementRef.getBoundingClientRect();
        }
        return this.elementRef.nativeElement.getBoundingClientRect();
    }

    getTop() {
        if (!this.util.hasValue(this.top)) {
            this.top = this.getRect().top + this.getRect().height;
        }
        return this.top;
    }
    getRight() {
        if (!this.util.hasValue(this.right)) {
            this.right =
                document.querySelector('body').offsetWidth -
                this.getRect().right;
        }
        return this.right >= this.getRect().left ? null : this.right; // If elementRef's location in on the right part of the window, render placenear to the left
    }
    getLeft() {
        if (!this.util.hasValue(this.left)) {
            this.left = this.getRect().left;
        }
        return this.left >=
            document.querySelector('body').offsetWidth - this.getRect().right // If elementRef's location in on the left part of the window, render placenear to the right
            ? null
            : this.left;
    }
}
